import { render, staticRenderFns } from "./ShareMultipleFormsModal.vue?vue&type=template&id=20d35ba8&scoped=true&"
import script from "./ShareMultipleFormsModal.vue?vue&type=script&lang=js&"
export * from "./ShareMultipleFormsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareMultipleFormsModal.vue?vue&type=style&index=0&id=20d35ba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d35ba8",
  null
  
)

export default component.exports